var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.9062C16.9566 13.9963 17.25 12.9932 17.25 11.9062C17.25 10.8042 16.9688 9.82494 16.5 8.90619M18.75 17.1562C19.6631 15.5624 20.25 14.1562 20.25 11.9062C20.25 9.65619 19.6875 8.26401 18.75 6.65619M7.38984 8.90619H4.125C4.02554 8.90619 3.93016 8.9457 3.85984 9.01603C3.78951 9.08635 3.75 9.18174 3.75 9.28119V14.5312C3.75 14.6306 3.78951 14.726 3.85984 14.7964C3.93016 14.8667 4.02554 14.9062 4.125 14.9062H7.38984C7.56318 14.9063 7.73114 14.9664 7.86516 15.0764L12.1528 18.592C12.2087 18.6331 12.275 18.6579 12.3441 18.6636C12.4133 18.6693 12.4827 18.6557 12.5446 18.6243C12.6065 18.593 12.6585 18.545 12.6947 18.4858C12.731 18.4266 12.7501 18.3586 12.75 18.2892V5.52322C12.75 5.4539 12.7307 5.38594 12.6944 5.3269C12.658 5.26786 12.606 5.22004 12.5442 5.18877C12.4823 5.15749 12.413 5.14398 12.3439 5.14973C12.2748 5.15548 12.2087 5.18027 12.1528 5.22135L7.86516 8.73697C7.73102 8.84658 7.56307 8.90637 7.38984 8.90619Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.c401e5aa4d663b876e6d309758d0bd01.svg";
export { ForwardRef as ReactComponent };